import React, { useState } from 'react';
import { Button, Form, Modal, Table, Message } from 'semantic-ui-react';
import { API, showError } from '../helpers';

export default function RequestDiagnostic({ requestId }) {
  const [id, setId] = useState(requestId || '');
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);
  const inspect = async () => {
    if (!(requestId || id).trim()) return;
    setBusy(true);
    try {
      const response = await API.get(`/api/platform/diagnostics/${encodeURIComponent((requestId || id).trim())}`);
      if (!response.data.success) throw new Error(response.data.message);
      setData(response.data.data);
    } catch (e) { showError(e.response?.data?.message || e.message); }
    finally { setBusy(false); }
  };
  const d = data?.diagnostic;
  const rows = d ? [
    ['请求 ID', d.request_id], ['时间', new Date(d.created_at * 1000).toLocaleString()],
    ['接口', `${d.method} ${d.path}`], ['用户 / 令牌 / 渠道', `${d.user_id} / ${d.token_id} / ${d.channel_id}`],
    ['请求模型 / 实际模型', `${d.model || '—'} / ${d.actual_model || '—'}`], ['上游地址', d.upstream_url || '未发送上游'],
    ['平台 / 上游状态码', `${d.status} / ${d.upstream_status || '—'}`], ['上游尝试次数', d.upstream_attempts],
    ['请求大小 / 消息 / 工具', `${d.request_bytes} 字节 / ${d.messages} / ${d.tools}`],
    ['输出上限：请求 / 实际', `${d.requested_max_tokens} / ${d.effective_max_tokens}`], ['估算输入 Token', d.estimated_input_tokens || '—'],
    ['平台前置耗时', d.upstream_attempts ? `${d.pre_upstream_ms} ms` : '未发送上游'],
    ['上游响应头耗时', d.upstream_attempts ? `${d.upstream_headers_ms} ms` : '—'],
    ['首客户端内容耗时', d.stream && d.first_content_ms ? `${d.first_content_ms} ms` : '—'], ['总耗时', `${d.total_ms} ms`],
    ['错误', d.error || '无'], ['钱包状态', data.wallet?.state || '无预占记录'],
    ['预占 / 扣费', data.wallet ? `${(data.wallet.reserved / 1e6).toFixed(6)} / ${(data.wallet.charged / 1e6).toFixed(6)} 元` : '—'],
    ['实际输入 / 输出 / 思考 Token', data.wallet ? `${data.wallet.prompt_tokens} / ${data.wallet.completion_tokens} / ${data.wallet.reasoning_tokens}` : '—'],
  ] : [];
  return <>
    {requestId ? <Button size='mini' loading={busy} onClick={inspect}>请求详情</Button> : <Form onSubmit={inspect}><Form.Group><Form.Input placeholder='输入请求 ID，查询成功或失败请求' value={id} onChange={e => setId(e.target.value)} width={12}/><Button type='submit' loading={busy}>查询请求详情</Button></Form.Group></Form>}
    <Modal open={Boolean(d)} onClose={() => setData(null)} closeIcon>
      <Modal.Header>请求诊断详情</Modal.Header>
      <Modal.Content scrolling>
        <Table basic='very' celled><Table.Body>{rows.map(([label, value]) => <Table.Row key={label}><Table.Cell>{label}</Table.Cell><Table.Cell style={{overflowWrap:'anywhere'}}>{String(value)}</Table.Cell></Table.Row>)}</Table.Body></Table>
        <Message>上游响应头耗时包含连接与供应商排队。首客户端内容可能是流式元事件，不等同于首个文本 Token。历史请求无法补录详情。</Message>
        {d?.bodies_enabled ? <><h4>脱敏请求正文</h4><pre style={{whiteSpace:'pre-wrap',overflowWrap:'anywhere'}}>{d.request_body}</pre><h4>脱敏响应正文</h4><pre style={{whiteSpace:'pre-wrap',overflowWrap:'anywhere'}}>{d.response_body}</pre></> : <p>正文记录已关闭。管理员可设置 PLATFORM_LOG_BODIES=true 并重启服务开启；正文可能包含对话或代码，最多记录 64 KiB。</p>}
      </Modal.Content>
    </Modal>
  </>;
}
